module.exports = __webpack_public_path__ + "img/NOT_ALLOWED.9ff2b9ea.svg";